import Skeleton from 'flow/components/ui-components/Skeleton';

const ToggleSkeleton = () => (
    <Skeleton>
        <div className="h-6 w-10 rounded-full bg-current" />
    </Skeleton>
);

export default ToggleSkeleton;
